import { useEffect } from "react";

export const UnveiledByYou = ({ onClose }) => {
    useEffect(() => {
        // Function to handle keydown event
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                onClose(); // Call the onClose function when Esc is pressed
            }
        };

        // Add event listener when the component mounts
        window.addEventListener("keydown", handleKeyDown);

        // Clean up event listener when the component unmounts
        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [onClose]);

    return (
        <>
            <div
                className="modal"
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflowY: "auto", // Enable scrolling for the modal
                    zIndex: 1050,

                }}
            >
                <div
                    className="modal-content"
                    style={{
                        padding: "20px",
                        background: "#fff",
                        borderRadius: "8px",
                        maxWidth: "500px",
                        width: "95%",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
                        maxHeight: "95vh", // Limit the modal height to viewport
                        overflowY: "auto", // Enable content scrolling within the modal
                    }}
                >
                    <div className="img-fluid mb-4">
                        <picture>
                            <img
                                src="/media/poemseng/unveiled-by-your-smile.jpg"
                                alt=" Unveiled by You | Lone Wolf writes "
                                style={{
                                    width: "100%",
                                    height: "18rem",
                                    objectFit: "cover",
                                    borderRadius: "6px",
                                    backgroundColor: "gray",
                                }}
                            />
                        </picture>
                    </div>

                    <h2 style={{ textAlign: "center", color: "red" }}>Unveiled by You</h2>
                    <hr />

                    <p style={{ textAlign: "center" }}>
                        I'm the kind of guy who holds his pride so high,<br />
                        I’d never spare myself if I dared let it die;<br />
                        But somehow, you conquer me with a simple grin,<br />
                        And I find my fortress crumbling from within.<br />
                        <br />
                        I'm the stubborn soul who forgives no flaw,<br />
                        Demanding perfection with an iron law;<br />
                        But in your eyes, a softness I can't defy,<br />
                        Turns my arrogance to grace, without knowing why.<br />
                        <br />
                        I'm the selfish one, the world’s noise I ignore,<br />
                        Focused on myself, wanting nothing more;<br />
                        Yet the sight of you walking my way makes me new,<br />
                        And suddenly, all I want is to give to you.<br />
                        <br />
                        I'm the reckless wanderer, careless and free,<br />
                        Unbothered by logic or what others might see;<br />
                        But the flicker of your fading smile strikes deep,<br />
                        And I tread with caution, where once I'd leap.<br />
                        <br />
                        I'm the heartless rogue, love is a foreign game,<br />
                        Even those I hold closest, I keep them the same;<br />
                        But a single text from you lights up my phone,<br />
                        And I’m awash with warmth I’ve never known.<br />
                        <br />

                    </p>

                    <div className="modal-footer" style={{ textAlign: "right" }}>
                        <button type="button" onClick={onClose} className="btn btn-secondary" style={{ backgroundColor: "red", border: 0, padding: "10px 20px", color: "#fff", borderRadius: "5px", }}>
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};
